var _style, _path, _defs, _g, _path2, _path3, _rect, _rect2, _rect3, _rect4, _path4, _path5, _path6, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegistrationSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 101.9 79.3",
    style: {
      enableBackground: "new 0 0 101.9 79.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.97;}\n\t.st1{fill:#83D0D7;}\n\t.st2{clip-path:url(#SVGID_2_);}\n\t.st3{fill:#4BBAC6;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:1.42;stroke-miterlimit:10;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#277A9E;}\n\t.st7{fill:#16BCC8;}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.7,22.3l2.8,53.8c0.1,1.4,1.2,2.4,2.6,2.3c0,0,0,0,0,0l71.6-3.8c1.4-0.1,2.4-1.2,2.3-2.6l-0.4-8.5 l-2.1-39.2l-0.7-12.6c-0.1-1.4-1.2-2.4-2.6-2.3c0,0,0,0,0,0l-62.3,3.3l-2.5,0.1c-0.6,0-1.2,0.3-1.7,0.8l-6.4,6.8 C18.9,21,18.6,21.6,18.7,22.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M18.7,22.3l2.8,53.8c0.1,1.4,1.2,2.4,2.6,2.3c0,0,0,0,0,0l71.6-3.8c1.4-0.1,2.4-1.2,2.3-2.6l-0.4-8.5 l-2.1-39.2l-0.7-12.6c-0.1-1.4-1.2-2.4-2.6-2.3c0,0,0,0,0,0l-62.3,3.3l-2.5,0.1c-0.6,0-1.2,0.3-1.7,0.8l-6.4,6.8 C18.9,21,18.6,21.6,18.7,22.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "17,22 27.7,21.2 27.2,11.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M17,22.6l9.4-0.7l1.3-0.1c0.3,0,0.6-0.3,0.6-0.6L28,13l-0.1-1.2c0-0.8-1.3-0.8-1.2,0l0.4,8.2l0.1,1.2 l0.6-0.6l-9.4,0.7L17,21.3C16.2,21.4,16.2,22.7,17,22.6L17,22.6z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M26.7,53.5c8.8-2.8,24.7-9.4,35-25.3c0.7-1.1,1.4-2.3,2-3.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M63.4,25.2c-1.9,0.6-4.6-0.1-6.3-0.9c3.2-0.5,6.2-1.8,8.7-3.8c-0.1,3.2,0.6,6.4,2,9.3 C66.1,28.8,64.1,27.2,63.4,25.2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 64.4,
    transform: "matrix(0.9986 -5.233596e-02 5.233596e-02 0.9986 -3.5231 1.7806)",
    className: "st5",
    width: 6.5,
    height: 7.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.8,
    y: 57.8,
    transform: "matrix(0.9986 -5.233596e-02 5.233596e-02 0.9986 -3.318 2.3919)",
    className: "st5",
    width: 6.5,
    height: 13.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52.6,
    y: 49.5,
    transform: "matrix(0.9986 -5.233596e-02 5.233596e-02 0.9986 -3.067 3.0038)",
    className: "st5",
    width: 6.5,
    height: 21.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 64.4,
    y: 42,
    transform: "matrix(0.9986 -5.233596e-02 5.233596e-02 0.9986 -2.8409 3.6177)",
    className: "st5",
    width: 6.5,
    height: 28
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M85.6,68.7h-1.3v-2.7C83,66,81.6,65.6,80.4,65c-1.5-1-2.3-2.7-2.3-5.2h3.6c0.1,0.8,0.2,1.5,0.5,2.2 c0.5,0.7,1.2,1.1,2,1.1l-0.1-5.7l-1.1-0.3c-1.4-0.3-2.6-1-3.6-2c-0.7-0.9-1.1-2-1.1-3.2c0-0.8,0.1-1.5,0.4-2.2 c0.3-0.7,0.7-1.3,1.2-1.8c0.6-0.6,1.3-1,2.1-1.3c0.7-0.2,1.4-0.3,2.1-0.3v-1.8h1.3v1.8c1.2,0,2.4,0.4,3.4,1c1.5,1,2.5,2.7,2.4,4.6 h-3.5c0-0.6-0.2-1.2-0.4-1.7c-0.4-0.6-1.1-1-1.8-1l0.1,5.1c1.5,0.4,2.9,1.1,4.3,1.9c1.2,0.9,1.9,2.4,1.8,3.9c0.2,2-0.8,3.8-2.4,4.9 c-1.1,0.7-2.3,1.1-3.6,1.1L85.6,68.7z M84.1,49.2c-0.6,0-1.2,0.2-1.7,0.6c-0.4,0.5-0.6,1-0.5,1.6c0,0.7,0.3,1.3,0.9,1.8 c0.4,0.3,0.9,0.5,1.4,0.7L84.1,49.2z M85.6,63.1c0.5,0,1.1-0.2,1.5-0.5c0.6-0.5,0.9-1.3,0.8-2.1c0-0.7-0.3-1.4-0.8-1.8 c-0.5-0.3-1-0.6-1.6-0.8L85.6,63.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M96.8,29.5c0.8-1.7,0.5-3.7-0.8-4.3s-3.3,0.9-3.8,2.1c-0.9,2.2-1.1,4.6-0.5,6.9c-2.2-3.5-4-6.6-5.5-9.4 c1.8-1.7,3.2-3.8,3.9-6.1c0.6-2.1,0.1-4.3-1.2-4.7s-3.1,1.8-3.5,3.3c-0.5,1.7-0.6,3.6-0.4,5.3c-2.6-5-3.9-8.4-4.2-9.1 c1.6-2,2.6-4.4,3-6.9c0.3-2.4-0.6-4.7-2.2-4.9S78.6,4.3,78.4,6c-0.2,1.9-0.1,3.8,0.4,5.6c-1.1-1.8-2.6-3.3-4.3-4.5 C72.5,5.8,70,5.7,69.2,7s0.9,3.9,2.3,4.8c2.4,1.4,5.2,2.2,8,2.1c1.2,3.1,2.6,6.1,4.2,9.1c-1.2-0.7-2.6-1.2-4-1.3 c-1.9-0.1-3.6,0.9-3.7,2.3s2,2.7,3.3,2.8c2,0.1,3.9-0.4,5.6-1.4c1.3,2.5,2.9,5.3,4.8,8.4c-1.9-1.3-4.1-2-6.4-2.3 c-2.3-0.2-4.3,0.9-4.4,2.3s2.5,2.8,4.1,2.9c2.6,0.1,5.2-0.5,7.5-1.8c2.5,4,5.5,8.4,9,13l1.2-0.8c-3.5-4.6-6.4-8.9-8.9-12.9 C93.8,33.2,95.6,31.6,96.8,29.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M28,41.6c0,0,4.5-9.6-2.8-12.6c0,0-13.9-3.8-19.3,0.8c0,0-9.3,6.3-1.1,14.4c0,0,0,4.3-1.2,5.3 c2.3,0.2,4.6-0.8,6.1-2.6C9.7,46.9,23.3,51.7,28,41.6z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 20.9,
    cy: 38,
    r: 1.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 15.9,
    cy: 38,
    r: 1.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 10.8,
    cy: 38,
    r: 1.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrationSuccess);
export default __webpack_public_path__ + "static/media/registration-success.b84af2a8bb1f5529e1810291c83f28f3.svg";
export { ForwardRef as ReactComponent };